import { render } from "./api-keys.vue?vue&type=template&id=bd976350&scoped=true"
import script from "./api-keys.vue?vue&type=script&lang=js"
export * from "./api-keys.vue?vue&type=script&lang=js"

import "./api-keys.vue?vue&type=style&index=0&id=bd976350&scoped=true&lang=css"

import exportComponent from "/home/runner/work/inventflux-frontend/inventflux-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bd976350"]])

export default __exports__